var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"cz-button",class:_vm.classes,attrs:{"disabled":_vm.disabled,"type":_vm.nativeType},on:{"click":_vm.clickFun}},[(_vm.icon)?_c('cz-icon',{attrs:{"name":_vm.icon}}):_vm._e(),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }